var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { noop } from 'lodash';
import async from 'async';
import { LooseGameSchema } from 'types/games';
import CompanyStore from 'stores/CompanyStore/store';
import GamesStore from 'stores/GamesStore/store';
import { initPusher, subscribeToAccountChannel, subscribeToGameChannel, unsubscribeFromChannel, getGameChannelName } from 'services/pusher';
import { getGameDate } from './window';
import API from './WebAPIUtils';
import { compareArray } from './GeneralUtils';
export var retrieveData = function (cb) {
    if (cb === void 0) { cb = noop; }
    API.fetchApplicationData(function (error, result) {
        if (!error && result) {
            // Always update the store with the data, validation errors are logged but not blocking
            CompanyStore.update(result);
            cb();
        }
    });
};
export var fetchGame = function (gameId, callback) {
    var baseQuery = { ie_fix: new Date().getTime() };
    var windowGameDate = getGameDate();
    var query = windowGameDate ? __assign(__assign({}, baseQuery), { date: windowGameDate }) : baseQuery;
    API.get("/reporting/getStandaloneGame/".concat(gameId), query, function (error, response) {
        var parsedResponse = LooseGameSchema.safeParse(response);
        if (parsedResponse.success) {
            GamesStore.setGame(gameId, parsedResponse.data);
        }
        else {
            console.error('Error parsing game response', parsedResponse.error);
        }
        callback(null);
    });
};
export var setupRealtimeSubscriptions = function (pusherKey) {
    var accountId = CompanyStore.getAccountId();
    // If account data isn't ready yet, skip realtime setup
    if (!accountId) {
        console.warn('Account ID not available, skipping realtime subscriptions');
        return;
    }
    // Initialize Pusher
    initPusher(pusherKey);
    var gameQueue = async.queue(function (task, callback) {
        fetchGame(task.game_id, callback);
    }, 3);
    var gameUpdateCallback = function (data) {
        if (data.game_id && GamesStore.hasGame(data.game_id)) {
            gameQueue.push({ game_id: data.game_id });
        }
    };
    var addGameCallback = function (gameId) {
        fetchGame(gameId, noop);
        subscribeToGameChannel(gameId, gameUpdateCallback);
    };
    var removeGameCallback = function (gameId) {
        GamesStore.deleteGame(gameId);
        unsubscribeFromChannel(function () { return getGameChannelName(gameId); });
    };
    subscribeToAccountChannel(accountId, function (data) {
        if (data.account_id && parseInt(String(data.account_id), 10) === accountId) {
            retrieveData(function () {
                var targetArray = CompanyStore.getAllGamesList();
                var existingArray = GamesStore.getGamesList();
                compareArray(existingArray, targetArray, addGameCallback, removeGameCallback);
            });
        }
    });
    // Subscribe to game channels
    var allGamesList = CompanyStore.getAllGamesList();
    allGamesList.forEach(function (gameId) {
        subscribeToGameChannel(gameId, gameUpdateCallback);
    });
};
